import { mapExtractDatesResponse, mapExtractOccupancyResponse } from './mappers/Search/naturalLanguageSearchMap'
import request from './requestUtils'
import { paths } from '@luxuryescapes/contract-search'

export type ExtractOccupancyResponse =
  paths['/api/search/hotel/v1/extract/occupancy']['post']['responses']['200']['content']['application/json']
export type ExtractOccupancyPayload =
  paths['/api/search/hotel/v1/extract/occupancy']['post']['parameters']['body']['payload']

export type ExtractDatesResponse =
  paths['/api/search/hotel/v1/extract/travel-dates']['post']['responses']['200']['content']['application/json']
export type ExtractDatesPayload =
  paths['/api/search/hotel/v1/extract/travel-dates']['post']['parameters']['body']['payload']
type ExtractDatesPayloadRegions =
  paths['/api/search/hotel/v1/extract/travel-dates']['post']['parameters']['body']['payload']['region']

export const extractDates =
  async(query: string, region: string): Promise<App.ExtractDatesResult> => {
    return request.post<ExtractDatesResponse, ExtractDatesPayload>(
      '/api/search/hotel/v1/extract/travel-dates',
      { query, region: region as ExtractDatesPayloadRegions },
      { excludeBrand: true }
    ).then(response => mapExtractDatesResponse(response))
  }

export const extractOccupancy =
  async(query: string): Promise<App.ExtractOccupancyResult> => {
    return request.post<ExtractOccupancyResponse, ExtractOccupancyPayload>(
      '/api/search/hotel/v1/extract/occupancy',
      { query },
      { excludeBrand: true }
    ).then(response => mapExtractOccupancyResponse(response))
  }
